<template>
  <div class="lltlocallaw">
    <!-- <sec-title Text="合肥律师" class="text_center" /> -->
	<div class="title">
		合肥律师
	</div>
    <div class="findlawlist between wrap">
      <div class="finditem" v-for="(item,index) in list.data" :key="index">
        <div class="topmafo between">
          <div class="lawsf">
            <div>
              <span class="name">{{item.lawyer_name}}</span> <span class="zhiye">律师</span>
            </div>
            <div class="cysj">执业 <span>14</span> 年</div>
          </div>
          <div class="lawcover">
            <img :src="item.avatar" alt="" />
          </div>
        </div>
        <div class="bomafo">
          <div class="bm1">
            <div class="wbm1">{{item.goodat}}</div>
            <div class="acbm1">
              <div class="txt">
                拥有16年行政诉讼案件经验。北京即明律师事务所主任律师，只专注于专业办理行政...
                <span>[更多]</span>
              </div>
              <div class="acbtn center">在线咨询</div>
            </div>
          </div>
          <div class="bm2 between">
            <div class="flex_start">
              <img
                src="../../../assets/findlawchild/llttlawdhicon.png"
                alt=""
              />
              {{item.lawyer_mobile}}
            </div>
            <div>帮助<span>{{item.helpnum}}</span>人</div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination mt30">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-count="list.last_page"
        :current-page="currentPage"
        :pager-count="5"
        @current-change="turnpage"
        @prev-click="turnpage(--currentPage)"
        @next-click="turnpage(++currentPage)"
      >
      </el-pagination>
      <div class="textnum">[共{{ list.last_page }}页]</div>
    </div>
  </div>
</template>


<script>
import secTitle from "views/home/components/secTitle";
export default {
	props:['list'],
  components: {
    secTitle,
  },
  data: () => ({
    currentPage: 1, //当前
    pageCount: 17, //总页数
    total: 17, //总条目
  }),
  methods: {
    turnpage(e) {
		this.$emit('turnpage',e)
      console.log(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.lltlocallaw {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;
  .title{
	  position: relative;
	  width: 200px;
	  height: 37px;
	  font-size: 38px;
	  font-weight: 500;
	  color: #333333;
	  line-height: 30px;
	  margin: 0 auto;
	  text-align: center;
  }
  .title::after{
	  position: absolute;
	  content: '';
	  top: 45px;
	  left: 50%;
	  margin-left: -35px;
	  width: 70px;
	  height: 4px;
	  background: #0465EA;
  }
  .findlawlist {
    padding-top: 8px;
    .finditem {
      margin-top: 26px;
      width: 286px;
      height: 246px;
      background: #ebcece;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      .topmafo {
        width: 100%;
        height: 156px;
        // background: #f1f7ff;
        border-radius: 10px 10px 0px 0px;
        padding-left: 20px;
        padding-right: 5px;
        .lawsf {
          .name {
            font-size: 28px;
            color: #333333;
            line-height: 28px;
            position: relative;
            &::before {
              position: absolute;
              content: "";
              top: -10px;
              left: 0;
              width: 22px;
              height: 3px;
              background: #b2d2ff;
            }
          }
          .zhiye {
            font-size: 18px;
            color: #333333;
            line-height: 18px;
          }
          .cysj {
            margin-top: 14px;
            font-size: 14px;
            color: #666666;
            span {
              color: #d70000;
            }
          }
        }
        .lawcover {
          align-self: flex-end;
          img {
            width: 120px;
            height: 140px;
          }
        }
      }
      .bomafo {
        transition: all 0.3s;
        position: absolute;
        width: 100%;
        height: 90px;
        background-color: #fff;
        bottom: 0;
        left: 0;
        padding: 16px;
        .bm1 {
          .wbm1 {
            font-size: 18px;
            color: #333333;
          }
          .acbm1 {
            display: none;
            .txt {
              font-size: 12px;
              color: #999999;
              line-height: 20px;
            }
            .acbtn {
              width: 76px;
              height: 24px;
              margin: 10px auto 0;
              background: #ec3b3b;
              border-radius: 12px;
              font-size: 14px;
              color: #ffffff;
              cursor: pointer;
            }
          }
        }
        .bm2 {
          font-size: 16px;
          color: #666666;
          background-color: #fff;
          position: absolute;
          width: 100%;
          left: 0;
          height: 40px;
          padding: 0 16px;
          bottom: 0;
          img {
            width: 16px;
            height: 18px;
            margin-right: 4px;
          }
          span {
            color: #d70000;
          }
        }
      }

      &:hover {
        .bomafo {
          height: 135px;
          .bm1 {
            .wbm1 {
              display: none;
            }
            .acbm1 {
              display: block;
            }
          }
        }
      }
      &:nth-child(1n) {
        .topmafo {
          background: url("../../../assets/findlawchild/llttlaw_bg1.png");
        }
      }
      &:nth-child(2n) {
        .topmafo {
          background: url("../../../assets/findlawchild/llttlaw_bg2.png");
        }
      }
      &:nth-child(3n) {
        .topmafo {
          background: url("../../../assets/findlawchild/llttlaw_bg3.png");
        }
      }
      &:nth-child(4n) {
        .topmafo {
          background: url("../../../assets/findlawchild/llttlaw_bg4.png");
        }
      }
      &:nth-child(5n) {
        .topmafo {
          background: url("../../../assets/findlawchild/llttlaw_bg5.png");
        }
      }
    }
  }
  .pagination {
    text-align: center;
    ::v-deep .el-pagination.is-background .btn-next,
    ::v-deep .el-pagination.is-background .btn-prev,
    ::v-deep  .el-pagination button,
    ::v-deep  .el-pagination span:not([class*="suffix"]),
    ::v-deep .el-pagination.is-background .el-pager li {
      min-width: 36px;
      height: 36px;
      line-height: 36px;
    }
    .textnum {
      color: #333;
      margin-top: 15px;
    }
  }
}
</style>